import React from "react";

import "../../styles/LogoScroller.scss";
import logos from "../../data/logos";

function LogoScroller() {
    return (
        <div className="logo-scroller">
            <div className="logos">
                {logos.map((logo) => (
                    <img
                        key={logo.id}
                        src={logo.img}
                        alt={logo.alt}
                        className="logo"
                        loading="lazy"
                        decoding="async"
                    />
                ))}
            </div>
            <div className="logos">
                {logos.map((logo) => (
                    <img
                        key={logo.id}
                        src={logo.img}
                        alt={logo.alt}
                        className="logo"
                        loading="lazy"
                        decoding="async"
                    />
                ))}
            </div>

        </div>
    );
}

export default LogoScroller;